/**
 * Coordinates with `breadcrumb-plp-context.js`:
 *
 * - Any page: clicks on `a[href]` inside `#header-group` set `ownd_breadcrumb_nav_from_header` so
 *   the next PLP/PDP load does not replace Liquid breadcrumbs with a short stored trail.
 * - Homepage → direct collection URL in **main content** (not header): persist
 *   `ownd_breadcrumb_trail` as [Home, collection]. Header menu collection clicks clear that trail.
 * - Main content (not header, not collection PLP, not modal) → product URL: persist
 *   `ownd_breadcrumb_home_pdp` with pathname so PDP can show **Home > Product** (like the short
 *   collection promo trail). Clears `ownd_breadcrumb_trail` so it does not fight this intent.
 *
 * Optional: `data-breadcrumb-title` on collection links for a custom crumb label.
 */
(function () {
  const STORAGE_KEY = 'ownd_breadcrumb_trail';
  const HOME_PDP_KEY = 'ownd_breadcrumb_home_pdp';
  const FROM_HEADER_NAV_KEY = 'ownd_breadcrumb_nav_from_header';

  function isStorefrontHome() {
    const p = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    return p === '/' || p === '/index';
  }

  function isCollectionPlpPath() {
    const p = window.location.pathname;
    return p.includes('/collections/') && !p.includes('/products/');
  }

  function isClickInModalLikeUi(el) {
    if (!(el instanceof Element)) return false;
    return !!el.closest(
      'dialog, ' +
        '[role="dialog"], ' +
        'quick-add-component, ' +
        '.quick-add-modal, ' +
        '[data-quick-add-modal], ' +
        'cart-drawer-component, ' +
        '.cart-drawer'
    );
  }

  /** @returns {string | null} pathname like /collections/handle or null */
  function directCollectionPathFromHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return null;
      if (u.pathname.includes('/products/')) return null;
      const m = u.pathname.match(/^\/collections\/([^/]+)\/?$/i);
      return m ? u.pathname.split('?')[0] : null;
    } catch {
      return null;
    }
  }

  /** @returns {string | null} pathname for a same-origin PDP link (canonical or within collection) */
  function directProductPathFromHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return null;
      const p = u.pathname.split('?')[0];
      if (/\/products\/[^/]+\/?$/i.test(p)) return p;
      return null;
    } catch {
      return null;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target instanceof Element ? e.target.closest('a[href]') : null;
      if (a) {
        try {
          if (a.closest('#header-group')) {
            sessionStorage.setItem(FROM_HEADER_NAV_KEY, '1');
          } else {
            sessionStorage.removeItem(FROM_HEADER_NAV_KEY);
          }
        } catch {}
      }

      const href = a ? a.getAttribute('href') || '' : '';

      if (isStorefrontHome() && a) {
        const colPath = directCollectionPathFromHref(href);
        if (colPath) {
          if (a.closest('#header-group')) {
            try {
              sessionStorage.removeItem(STORAGE_KEY);
            } catch {}
          } else {
            const title =
              (a.getAttribute('data-breadcrumb-title') || '').trim() ||
              (a.getAttribute('title') || '').trim() ||
              (a.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120) ||
              '';
            try {
              sessionStorage.removeItem(HOME_PDP_KEY);
              sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify([{ title: 'Home', url: '/' }, { title, url: colPath }])
              );
            } catch {}
          }
          return;
        }
      }

      if (!a) return;

      const productPath = directProductPathFromHref(href);
      if (!productPath) return;

      if (a.closest('#header-group')) {
        try {
          sessionStorage.removeItem(HOME_PDP_KEY);
        } catch {}
        return;
      }

      if (isCollectionPlpPath() || isClickInModalLikeUi(e.target)) {
        return;
      }

      try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.setItem(HOME_PDP_KEY, JSON.stringify({ path: productPath }));
      } catch {}
    },
    true
  );
})();
